import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, ModalOptions, BsModalRef } from 'ngx-bootstrap';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Allocation } from './allocation';
import { AllocationService } from './allocation.service';
import { UserService } from './../user/user.service';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-allocation',
  templateUrl: './allocation.component.html',
  styleUrls: ['./allocation.component.css']
})

export class AllocationComponent implements OnInit {
  sendMenuId: number;
  sendPageName: string = 'Allocation';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  allocationForm: FormGroup;
  allocations: Allocation[] = [];
  allocationsactive: Allocation[] = [];
  allocation: Allocation;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  allocationModalRef: BsModalRef;
  operation: string;
  userid: number;
  //allocationid: number;
  submitted = false;
  //active: number;
  // unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    ignoreBackdropClick: true,
    class: 'modal-dialog-centered'

  }
  showall: boolean = true;
  showallstatus: boolean = false;
  key: string = 'allocation'; //set default
  reverse: boolean = false;
  NotificationMailDDLSettings: any; notificationmailids: any = []; selectedMailids: any = [];
  
  focusinto: boolean = false;


  constructor(
    private allocationservice: AllocationService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService, private userService: UserService,
    private localService: LocalService) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('Allocation_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('Allocation_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('Allocation_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('Allocation_action');
    } 
  }

  ngOnInit() {
    this.checkIsMenuMapped();
    this.allocationForm = this.formBuilder.group({
      allocationid: [''],
      allocation: ['', [Validators.required]],
      notificationmailid: [''],
      externalmailid: [''],
      active: ['']
    });
    this.searchText = '';
    this.getAll();
    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();

    this.NotificationMailDDLSettings = {
      singleSelection: false,
      idField: 'userid',
      textField: 'emailid',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      //itemsShowLimit:2,
      allowSearchFilter: true
    };

  }

 
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  getAll() {
    this.allocations = [];
    this.allocationsactive = [];

    this.userService.GetActive().toPromise().then(res => {
      this.notificationmailids = res;//.map(obj => { obj.emailid });

     

      this.allocationservice.Get().subscribe(res => {
        this.allocations = res;
        this.allocations.forEach((data, ind) => {
          //if (ind >= 79) {
          if (data.notificationemaild) {
            let a = this.framemailIds(JSON.parse(data.notificationemaild))
            //data.notificationmailid = a// this.framemailIds(JSON.parse(data.notificationmailid))
            data['notificationmailidtext'] = a
            // }
          }
          if (data.externalmailid) {
            data['externalmailidtext'] = this.getemailstring(JSON.parse(data.externalmailid));
          }
        })

        if (this.showallstatus == true) {
          this.allocations.forEach(data => {
            if (data.active == 1) {
              this.allocationsactive.push(data);
            }
          });
          this.allocations = [];
          this.allocations = this.allocationsactive;
        }
      }, error => { this.toastr.error('Error while getting data'); });

    }, err => { this.toastr.error("not Able to get Users Data") })



  }

  getactiveinactive(showallp) {
    this.allocationsactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.allocations.forEach(data => {
        if (data.active == 1) {
          this.allocationsactive.push(data);
        }
      });
      this.allocations = [];
      this.allocations = this.allocationsactive;
    }
    else {
      this.showall = true;
      this.allocations = [];
      this.getAll();
    }
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedallocation");
    let data = arrays.find(ob => ob['name'] === 'Allocation');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedallocation","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedallocation",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    this.selectedMailids = [];
    this.allocationForm.reset();
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.allocationModalRef.hide();
  }

  get g() { return this.allocationForm.controls; }

  Post(allocation: Allocation) {
    var mailIds = {};
    this.submitted = true;
    // stop here if form is invalid
    if (this.allocationForm.invalid) {
      //console.log(this.g);
      // console.log(this.branchForm.errors);
    }

    if ((allocation.allocation.trim() == undefined) || (allocation.allocation.trim() == '')) {
      this.toastr.error('allocation should not be empty');
      return;
    }

    var msg = null;

    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    allocation.allocation = allocation.allocation.trim();
    mailIds['mailto'] = this.mailSaveStructure(this.selectedMailids)
    allocation.notificationemaild = JSON.stringify(mailIds);
    //Code to add external maids
    var regxpat = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    var validmailid = false; var externalMailList = []
    if (allocation.externalmailid) {
      if (allocation.externalmailid.trim() != null && allocation.externalmailid.trim() !== '') {
        let b = allocation.externalmailid.split(';')
        b.forEach(data => {
          if (!regxpat.test(data)) {
            this.toastr.warning('Please enter valid  External Mail id instead of ' + data)
            validmailid = false
          }
          else {
            externalMailList.push(data);
            validmailid = true;
          }
        })
        if (!validmailid) {
          return
        }
      }
    }
    this.allocationForm.value.externalmailid = JSON.stringify(externalMailList);


    if (this.operation == 'add') {

      allocation.createdby = this.userid;
      msg = "Record Added Successfully";
      this.allocationservice.Post(allocation).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              //this.allocationModalRef.hide();
              //this.selectedMailids = [];
              this.clearForm();
              this.getAll();
              this.toastr.success('Data added successfully');
             
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      allocation.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.allocationservice.Put(allocation).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              //this.allocationModalRef.hide();
              this.clearForm();
              this.getAll();
              this.toastr.success('Data updated successfully');
             
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    // console.log(this.allocationForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.allocationForm.value.active = 1;
    } else {
      this.allocationForm.value.active = 0
    }
  }

  OpenConfirmTemplate(allocati) {
    if (allocati.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.allocation = allocati;

          this.Delete();

        }

      });

  }

  Delete() {

    var msg;
    if (this.allocation.active == 0) {
      this.allocation.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.allocation.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    this.allocation.modifiedby = this.userid;

    this.allocationservice.Delete(this.allocation).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }

  hidePopup() {
    this.allocationModalRef.hide();
  }

  openAllocationModal(template: TemplateRef<any>, type, allocation?: Allocation) {


    this.operation = type
    if (type == 'update') {
      this.allocationForm.controls['allocationid'].setValue(allocation.allocationid);
      this.allocationForm.controls['allocation'].setValue(allocation.allocation);
      this.selectedMailids = this.getcustomlist(JSON.parse(allocation.notificationemaild));
      var extmailids = this.getemailstring(JSON.parse(allocation.externalmailid))
      this.allocationForm.controls['externalmailid'].setValue(extmailids);

      this.allocationForm.controls['active'].setValue(allocation.active);
      this.allocation = allocation;
    }
    if (type == 'add') {
      this.allocationForm.controls['allocationid'].setValue(0);
      this.allocationForm.controls['allocation'].setValue('');
      this.allocationForm.controls['active'].setValue(1);
    }
    this.allocationModalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");
  }

  mailSaveStructure(list) {
    var temp = [];


    if (list.length > 0) {
      list.forEach(item => {
        temp.push({ userid: item.userid })
      })

    }
    return temp;
  }

  getcustomlist(idlist) {

    var tempList = [];
    if (idlist) {
      var idList = idlist.mailto
      if ((idList != null) && (idList.length != 0)) {

        idList.forEach((d) => {
          this.notificationmailids.forEach((data, ind) => {
            if (data.userid == d.userid) {
              tempList.push({
                userid: data.userid, emailid: data.emailid
              });
            }
          });
        });

      }
    }

    return tempList;
  }

  framemailIds(useridlist) {
    var mailids = ''
    var useridList = useridlist.mailto;
    if (useridList.length > 0) {
      useridList.forEach((d) => {
        this.notificationmailids.forEach((data, ind) => {
          if (data.userid == d.userid) {
            //if (d.emailid) {
            if (mailids == '')
              mailids = data.emailid;
            else
              mailids = mailids + ',' + data.emailid;

            //}
          }
        });
      });
    }

    return mailids
  }

  getemailstring(externallist) {
    if (externallist) {
      var externalToliststr = '';
      externallist.forEach((d) => {
        if (externalToliststr == '')
          externalToliststr = d;
        else
          externalToliststr = externalToliststr + ';' + d;
      });
    }
    return externalToliststr
  }

}
